import React from "react";

const items = [
  {
    icon: "/images/fait-main.png",
    title: "Fait main",
    desc: "Chaque pièce est réalisée à la main, point après point.",
  },
  {
    icon: "/images/securite-des-paiements.png",
    title: "Paiement sécurisé",
    desc: "Toutes les transactions sont protégées via Stripe.",
  },
  {
    icon: "https://cdn-icons-png.flaticon.com/512/1086/1086933.png",
    title: "Confection locale",
    desc: "Une création artisanale, pensée et cousue avec soin.",
  },
];

const Engagements = () => (
  <section className="section section-engagements engagements">
    <div className="container">
      <div className="section-heading stitch-reveal">
        <div>
          <span className="eyebrow">Savoir-faire</span>
          <h2 className="section-title">Nos engagements</h2>
          <p className="section-text">Ce qui fait la différence chez Deenzine.</p>
        </div>
      </div>

      <div className="engagements-grid">
        {items.map((item) => (
          <div key={item.title} className="stitch-card engagement-card stitch-reveal">
            <span className="engagement-icon">
              <img src={item.icon} alt="" width="28" height="28" loading="lazy" />
            </span>
            <h3 className="h3">{item.title}</h3>
            <p className="p">{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Engagements;